import { formatPhone } from '../../../utils';
import { useFishDetails } from '../FishDetailsContext';
import CapturedFormsSection from './CapturedFormsSection';
import { Card } from '@Components/Card/index';
import LoadingSpinner from '@Components/LoadingSpinner';
import ShowFor from '@Components/ShowFor';
import Select from 'react-select';
import { darkSelectStyles } from '@Utils/selectStyles';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { Separator } from '@art-of-hospitality-solutions-llc/ui-kit/components/separator';

export default function ProfilePanel() {
  const {
    actor,
    handleHomeBaseUpdate,
    homeBaseCopy,
    homeBaseDisplayHandler,
    homeBaseMessage,
    homeBaseOptions,
    isEditing,
    isLoading,
    selectedHomeBase,
    setActor,
    setHomeBaseCopy,
    setHomeBaseMessage,
    setIsEditing,
  } = useFishDetails();

  return (
    <>
                  <Card>
                    <div className="gap-12 px-4">
                      {isLoading ? (
                        <LoadingSpinner />
                      ) : (
                        <>
                          <div className="flex flex-col">
                            <div className="w-full pb-4">
                              <Separator className="bg-aoh-accent dark:bg-[#caab6a]" />
                              <Heading level={'h5'}>Contact Information</Heading>
                              <Separator className="bg-aoh-accent dark:bg-[#caab6a]" />
                            </div>
  
                            <div className="text-muted-foreground font-bold">
                              Name:
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.fName +
                                  ' ' +
                                  actor?.memberProfile?.lName
                                : actor?.fishProfiles[0]?.fName +
                                  ' ' +
                                  actor?.fishProfiles[0]?.lName}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              Email:
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.email || 'N/A'
                                : actor?.fishProfiles[0]?.email || 'N/A'}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              Phone Number
                            </div>
                            <div>{formatPhone(actor.phoneNumber)}</div>

                            <div className="text-muted-foreground pt-4 font-bold">
                              SMS Opt-In
                            </div>
                            <div>{actor?.smsOptIn ? 'Opted in' : 'Not opted in'}</div>
  
                            <div className="w-full pt-4">
                              <Separator className="bg-aoh-accent dark:bg-[#caab6a]" />
                              <Heading level={'h5'}>Address</Heading>
                              <Separator className="bg-aoh-accent dark:bg-[#caab6a]" />
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              Address Line 1
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.addressLine1 || 'N/A'
                                : actor?.fishProfiles[0]?.addressLine1 || 'N/A'}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              Address Line 2
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.addressLine2 || 'N/A'
                                : actor?.fishProfiles[0]?.addressLine2 || 'N/A'}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              City
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.city || 'N/A'
                                : actor?.fishProfiles[0]?.city || 'N/A'}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              State
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.state || 'N/A'
                                : actor?.fishProfiles[0]?.state || 'N/A'}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              Country
                            </div>
                            {/*Using US as default country for now similar to membership*/}
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.country || 'US'
                                : actor?.fishProfiles[0]?.country || 'N/A'}
                            </div>
  
                            <div className="text-muted-foreground pt-4 font-bold">
                              Zip
                            </div>
                            <div>
                              {actor?.memberProfile
                                ? actor?.memberProfile?.zip || 'N/A'
                                : actor?.fishProfiles[0]?.zip || 'N/A'}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </Card>
                  <Card>
                    <div className="flex gap-12 px-4">
                      <div className="flex flex-col">
                        <div className="text-muted-foreground font-bold">
                          LinkedIn:
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.social_LinkedIn || 'N/A'
                            : actor?.fishProfiles[0]?.social_LinkedIn || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Instagram:
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.social_Instagram || 'N/A'
                            : actor?.fishProfiles[0]?.social_Instagram || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          TikTok:
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.social_TikTok || 'N/A'
                            : actor?.fishProfiles[0]?.social_TikTok || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          YouTube:
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.social_YouTube || 'N/A'
                            : actor?.fishProfiles[0]?.social_YouTube || 'N/A'}
                        </div>
                      </div>
                    </div>
                  </Card>
                  <Card>
                    <div className="flex gap-12 px-4">
                      <div className="flex flex-col">
                        <div className="text-muted-foreground font-bold">
                          What is your preferred name?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_Name || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_Name || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          What company do you work for?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_Company || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_Company ||
                              'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Professional title:
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_JobTitle || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_JobTitle ||
                              'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Are you looking to use the club for business, personal,
                          or both?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile
                                ?.preferences_BusinessOrPersonal || 'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_BusinessOrPersonal || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          What is your favorite restaurant By Landmark?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile
                                ?.preferences_LandmarkFavRestaurant || 'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_LandmarkFavRestaurant || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          What type of club events would you be most excited to
                          attend?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_PreferredEvents ||
                              'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_PreferredEvents || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Spouse/partner? If yes, please provide their name
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_Spouse || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_Spouse || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Outside of By Landmark, what are your favorite
                          restaurants?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile
                                ?.preferences_OtherFavRestaurants || 'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_OtherFavRestaurants || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          What is your preferred type of cuisine?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile
                                ?.preferences_PreferredCuisine || 'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_PreferredCuisine || 'N/A'}
                        </div>
  
                        {/*don't have these as options yet*/}
                        {/* <div className="font-bold text-(--muted-foreground) pt-4">
                          Are you interested in any of the following categories?
                        </div>
                        <div>{actor?.fishProfiles[memberProfileIndex]?.preferences_InterestInCategories || 'N/A'}</div> */}
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Do you like to travel? If so, where and how often do you
                          travel?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_TravelFrequency ||
                              'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_TravelFrequency || 'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          Do you have a favorite US city to visit?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_FavUsCity || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_FavUsCity ||
                              'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          What do you like to drink?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_FavDrink || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_FavDrink ||
                              'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          If you smoke cigars, do you have a favorite?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile?.preferences_FavCigars || 'N/A'
                            : actor?.fishProfiles[0]?.preferences_FavCigars ||
                              'N/A'}
                        </div>
  
                        <div className="text-muted-foreground pt-4 font-bold">
                          How often do you entertain?
                        </div>
                        <div>
                          {actor?.memberProfile
                            ? actor?.memberProfile
                                ?.preferences_EntertainingFrequency || 'N/A'
                            : actor?.fishProfiles[0]
                                ?.preferences_EntertainingFrequency || 'N/A'}
                        </div>
                      </div>
                    </div>
                  </Card>
                  <CapturedFormsSection />
                  <Card className="p-8">
                    <Separator className="bg-aoh-accent dark:bg-[#caab6a]" />
                    <div className="flex flex-row justify-between">
                      <div>
                        <Heading level={'h5'} className="">
                          Stork Club Homebase:
                        </Heading>
                        <p>
                          {actor?.memberProfile?.homeBase
                            ? homeBaseDisplayHandler(
                                actor?.memberProfile?.homeBase,
                              )
                            : 'N/A'}
                        </p>
                        {homeBaseMessage && (
                          <p
                            className={`text-sm ${homeBaseMessage === 'Homebase successfully updated' ? 'text-green-600' : 'text-red-600'}`}
                          >
                            *{homeBaseMessage}
                          </p>
                        )}
                      </div>
  
                      {!isEditing ? (
                        <ShowFor permissions={['MEMBERS_WRITE']}>
                          <Button
                            onClick={() => {
                              setIsEditing(true);
                              setHomeBaseMessage('');
                              setHomeBaseCopy(
                                actor?.memberProfile?.homeBase || null,
                              );
                            }}
                            size={'lg'}
                            className="w-1/4"
                            data-testid={'my-profile-edit-button'}
                          >
                            Click to edit
                          </Button>
                        </ShowFor>
                      ) : (
                        <div className="w-1/4 space-y-4">
                          <Button
                            onClick={() => {
                              handleHomeBaseUpdate(
                                actor?.memberProfile?.homeBase,
                              );
                            }}
                            size={'lg'}
                            className="w-full"
                            data-testid={
                              'my-profile-save-changes-homebase-button'
                            }
                            disabled={
                              actor?.memberProfile?.homeBase === homeBaseCopy
                            }
                          >
                            Save Changes
                          </Button>
                          <Button
                            onClick={() => {
                              setActor((prevActor) => ({
                                ...prevActor,
                                memberProfile: {
                                  ...prevActor.memberProfile,
                                  homeBase: homeBaseCopy,
                                },
                              }));
                              setIsEditing(false);
                            }}
                            size={'lg'}
                            variant={'outline'}
                            className="w-full"
                            data-testid={'my-profile-cancel-edit-button'}
                          >
                            Cancel
                          </Button>
                        </div>
                      )}
                    </div>
                    <Separator className="bg-aoh-accent dark:bg-[#caab6a]" />
  
                    <div className="">
                      {isEditing && (
                        <Select
                          className="pb-4"
                          styles={darkSelectStyles}
                          value={
                            homeBaseOptions.find(
                              (option) =>
                                option.value === actor?.memberProfile?.homeBase,
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            setActor((prevActor) => ({
                              ...prevActor,
                              memberProfile: {
                                ...prevActor.memberProfile,
                                homeBase: selectedOption
                                  ? selectedOption.value
                                  : null,
                              },
                            }));
                          }}
                          options={homeBaseOptions}
                          isDisabled={!isEditing}
                          placeholder="Select a Stork Club location"
                        />
                      )}
                      {selectedHomeBase?.image && (
                        <div>
                          <img
                            src={selectedHomeBase.image}
                            alt={selectedHomeBase.label}
                            className="mx-auto h-full w-full object-cover"
                          />
                        </div>
                      )}
                    </div>
                  </Card>
    </>
  );
}
